import "./style.scss"
const FooterCom = () => {
    return (
        <div className="footer">
            Copyright © 2025 SINO-BUS. All rights reserved.
            <p> 版权所有 © 2025 汉和文化科技（深圳）有限公司</p>
        </div>
    )
}
export default FooterCom;